<template>
    <v-app id="inspire">
        <v-layout row justify-center>
            <v-dialog v-model="onShow" persistent max-width="40%">
                <v-card>
                    <v-card-title>
                        <span class="subheading">MARS - MAC-Pool: {{ macPool.name }} - Reservation Request</span>

                    </v-card-title>

                    <v-divider></v-divider>

                    <v-container grid-list-xs style="margin-top: -20px">
                        <v-layout wrap>

                            <v-flex class="modal-flex-height" xs12>
                                <v-subheader class="body-2">Reservation for MAC-Pool {{ macPool.name }} (ID: {{
                                    macPool.poolId }}, OUI: {{
                                    macPool.oui }})
                                </v-subheader>
                            </v-flex>

                            <v-flex xs6 sm4 md6 class="modal-flex-height">
                                <v-subheader>Max. MACs per request:</v-subheader>
                            </v-flex>
                            <v-flex xs6 sm8 md5 class="modal-flex-height">
                                <v-subheader><b>{{macPool.macsPerReq}}</b></v-subheader>
                            </v-flex>


                            <v-flex xs6 sm4 md6 class="modal-flex-height">
                                <v-subheader>Max. MACs per user and day:</v-subheader>
                            </v-flex>
                            <v-flex xs6 sm8 md5 class="modal-flex-height">
                                <v-subheader><b>{{macPool.macsPerUserDay}}</b></v-subheader>
                            </v-flex>

                            <v-flex xs6 sm4 md6 class="modal-flex-height">
                                <v-subheader>Available MACs for your user today:</v-subheader>
                            </v-flex>
                            <v-flex xs6 sm8 md5 class="modal-flex-height">
                                <v-subheader><b>{{availableMacsForCurrentUserToday}}</b></v-subheader>
                            </v-flex>


                            <v-flex xs6 sm4 md6 class="modal-flex-height">
                                <v-subheader>Amount of MAC-Addresses:</v-subheader>
                            </v-flex>
                            <v-flex xs2 sm2 md2 class="modal-flex-height">


                                <v-text-field id="reservation_amount_field" v-model="reservationAmount" class="mt-0"
                                              type="number"></v-text-field>
                            </v-flex>
                            <v-flex xs3 sm4 md3 class="modal-flex-height" style="margin-left: 30px">
                                <v-slider v-model="reservationAmount" :max="macPool.macsPerReq"
                                          :disabled="true"></v-slider>

                            </v-flex>
                        </v-layout>
                    </v-container>


                    <v-divider></v-divider>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn id="send_reservation_request_button" class="text-none" dark small
                               @click="onSendReservationRequest">Reserve
                        </v-btn>
                        <v-btn id="cancel_reservation_button" class="text-none" small @click="close">Cancel</v-btn>
                    </v-card-actions>
                </v-card>

                <MacPoolReservationResponseModal v-model="showResponseModal" v-if="showResponseModal"
                                                 :macReservationDto="macReservationDto"
                                                 :rangeOfReservedMacs="rangeOfReservedMacs"></MacPoolReservationResponseModal>

                <MacPoolReservationFailedModal v-model="showRequestFailedModal" v-if="showRequestFailedModal"
                                               :macPool="macPool" :responseStatus="responseStatus"
                                               :responseData="requestResponseData"></MacPoolReservationFailedModal>

            </v-dialog>
        </v-layout>
    </v-app>
</template>

<script>

    import MacPoolReservationResponseModal from './MacPoolReservationResponseModal.vue';
    import MacPoolReservationFailedModal from './MacPoolReservationFailedModal.vue';
    import reservationinterface from "../../../interfaces/reservationinterface";
    import macaddressservice from "../../../services/macaddressservice";

    export default {
        name: 'MacPoolReservationRequestModal',

        props: {
            value: Boolean,

            macPool: {
                poolId: Number,
                oui: String,
                name: String,
                startMac: String,
                endMac: String,
                nextMac: String,
                available: Number,
                availableInPercent: Number,
                capacity: Number,
                isActive: Boolean,
                macsPerReq: Number,
                macsPerUserDay: Number,
                rowVersion: Array
            },

            availableMacsForCurrentUserToday: Number
        },


        data: () => ({
            reservationAmount: 0,
            macReservationDto: null,

            showResponseModal: false,
            showRequestFailedModal: false,

            requestResponseData: null,

            rangeOfReservedMacs: null,

            responseStatus: 0
        }),

        components: {
            MacPoolReservationFailedModal,
            MacPoolReservationResponseModal
        },


        computed: {
            onShow: {
                get() {
                    return this.value
                },
                set(value) {
                    this.$emit('input', value)
                }
            }
        },

        methods: {

            async onSendReservationRequest() {

                let macReservationDto = {
                    poolId: this.macPool.poolId,
                    amountOfMacsToReserve: this.reservationAmount
                };

                let responseData = null;
                await reservationinterface.reserveMacs(macReservationDto, response => {
                    responseData = response;
                });

                if (responseData && responseData.status === 200) {
                    await this.close();

                    this.macReservationDto = responseData.data;
                    macaddressservice.getReservedMacAddressList(this.macReservationDto.firstReservedMac, this.macReservationDto.lastReservedMac, this.macReservationDto.pool.oui, macs => {
                        this.rangeOfReservedMacs = macs
                    });
                    this.showResponseModal = true;
                } else {
                    await this.close();

                    this.responseStatus = responseData.status;
                    this.requestResponseData = responseData.data;
                    this.showRequestFailedModal = true;
                }
            },

            async close() {
                this.onShow = false;
                this.availableMacsForCurrentUserToday = 0;
                this.reservationAmount = 0;
            }
        }
    };


</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/macpools/modals/MacPoolReservationRequestModal.vue